import { useQuery } from 'react-query';

import { simpleKy } from 'src/services/api/ky';
import { queryKeys } from 'src/services/api/constants';

const PATH = 'api/landlord/onboard/config';

export type OnboardingConfig = {
    LANDLORD_ONBOARD_CODE_LENGTH: number;
    MIN_PASSWORD_LENGTH: number;
};

export const useOnboardingConfig = () => {
    return useQuery(
        [queryKeys.onboardingConfig],
        () => simpleKy(PATH).json<OnboardingConfig>(),
    );
};